type DemoAnalyticsPayload = Record<string, string | number | boolean | null | undefined>;

/**
 * Lightweight funnel events. Prefer window analytics if present; always console in non-prod.
 */
export function trackDemoEntryAnalysisEvent(
  event: string,
  payload: DemoAnalyticsPayload = {}
): void {
  const name = event.startsWith("demo_") ? event : `demo_${event}`;
  try {
    const w = typeof window !== "undefined" ? (window as unknown as {
      analytics?: { track?: (n: string, p?: DemoAnalyticsPayload) => void };
      dataLayer?: Array<Record<string, unknown>>;
    }) : null;
    w?.analytics?.track?.(name, payload);
    w?.dataLayer?.push({ event: name, ...payload });
  } catch {
    // ignore analytics failures
  }
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.info(`[demo-ea] ${name}`, payload);
  }
}
